<template>
  <v-container>
    <v-form ref="form" v-model="valid">
      <v-row>
        <v-col :cols="getDeviceType === 'touch' ? 12 : 6">
          <v-autocomplete 
          dense
            v-model="selectTip"
            :items="getTypesFilter"
            :search-input.sync="searchVrste"
            label="Odaberi tip rada"
            item-text="naziv"
            return-object
            outlined
          >
          </v-autocomplete>
        </v-col>
        <v-col
          :cols="getDeviceType === 'touch' ? 12 : 5"
          v-show="selectTip !== null && vrsteRada.length > 0"
        
        >
          <v-autocomplete 
          dense
            v-model="selectVrsta"
            :items="vrsteRada"
            label="Odaberi vrstu rada"
            item-text="naziv"
            return-object
            outlined
            :class="$vuetify.breakpoint.mdAndUp? 'ml-1 pl-1': 'mt-n6 ml-0 pl-0'"
          >
          </v-autocomplete>
        </v-col>
      </v-row>

      <v-row v-show="selectTip !== null" no-gutters>
        <v-col
          :cols="getDeviceType === 'touch' ? 12 : 3"
          v-if="selectTip && selectTip.doi !== null"
          :class="!$vuetify.breakpoint.mdAndUp? 'mt-n2': 'mt-n3'"
        >
          <v-text-field
           :class="!$vuetify.breakpoint.mdAndUp? '': 'pr-3'"
          dense v-model="doi" label="DOI" outlined></v-text-field
        ></v-col>
        <v-col
          :cols="getDeviceType === 'touch' ? 12 : 3"
          v-if="selectTip && selectTip.datum_izlozbe !== null"
          :class="!$vuetify.breakpoint.mdAndUp? 'mt-n2': 'mt-n3'"
        >
          <v-text-field
          :class="!$vuetify.breakpoint.mdAndUp? '': 'pr-3'"
          dense
            v-model="datum_izlozbe"
            label="Datum izložbe"
            outlined
          ></v-text-field
        ></v-col>
        <v-col
          :cols="getDeviceType === 'touch' ? 12 : 3"
          v-if="selectTip && selectTip.mjesto_izlozbe !== null"
          :class="!$vuetify.breakpoint.mdAndUp? 'mt-n2': 'mt-n3'"
        >
          <v-text-field
           :class="!$vuetify.breakpoint.mdAndUp? '': 'pr-3'"
          dense
            v-model="mjesto_izlozbe"
            label="Mjesto izložbe"
            outlined
          ></v-text-field
        ></v-col>
        <v-col
          :cols="getDeviceType === 'touch' ? 12 : 3"
          v-if="selectTip && selectTip.datum_obrane !== null"
          :class="!$vuetify.breakpoint.mdAndUp? 'mt-n2': 'mt-n3'"
        >
          <v-text-field
          :class="!$vuetify.breakpoint.mdAndUp? '': 'pr-3'"
          dense
            v-model="datum_obrane"
            label="Datum obrane"
            outlined
          ></v-text-field
        ></v-col>
        <v-col
          :cols="getDeviceType === 'touch' ? 12 : 3"
          v-if="selectTip && selectTip.godiste !== null"
          :class="!$vuetify.breakpoint.mdAndUp? 'mt-n2': 'mt-n3'"
        >
          <v-text-field
           :class="!$vuetify.breakpoint.mdAndUp? '': 'pr-3'"
          dense v-model="godiste" label="Godište" outlined></v-text-field
        ></v-col>
      </v-row>
    </v-form>
    <v-dialog v-model="showDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Vrsta</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-text-field
              class="pr-3"
              dense
                v-model="novaVrsta"
                label="Unesi naziv vrste" outlined
              ></v-text-field>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" small @click="createNewVrsta"
            >Dodaj vrstu</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: ["types"],
  computed: {
    ...mapGetters([
      "getTypesFilter",
      "getTip",
      "getVrsta",
      "getNovaVrsta",
      "getDoi",
      "getDatumIzlozbe",
      "getMjestoIzlozbe",
      "getDatumObrane",
      "getDeviceType",
      "getGodiste",
    ]),
    searchVrste: {
      set(value) {
        if (value != this.search) {
          this.search = value;
          this.$store.dispatch("getTypesFilter", value);
        }
      },
      get() {
        return "";
      },
    },
    selectedTypeName() {
      if (this.selectTip) {
        return this.selectTip.naziv;
      } else return [];
    },
    vrsteRada() {
      if (this.selectTip) {
        return this.selectTip.vrste_rada;
      } else return [];
    },
    tipIzdanja() {
      if (this.selectTip) {
        return this.selectTip.tip_izdanja;
      } else return {};
    },
    selectTip: {
      set(value) {
        this.$store.dispatch("setTip", value);
      },
      get() {
        return this.getTip;
      },
    },
    selectVrsta: {
      set(value) {
        this.$store.dispatch("setVrsta", value);
      },
      get() {
        return this.getVrsta;
      },
    },
    novaVrsta: {
      set(value) {
        this.$store.dispatch("setNovaVrsta", value);
      },
      get() {
        return this.getNovaVrsta;
      },
    },
    doi: {
      set(value) {
        this.$store.dispatch("setDoi", value);
      },
      get() {
        return this.getDoi;
      },
    },
    mjesto_izlozbe: {
      set(value) {
        this.$store.dispatch("setMjestoIzlozbe", value);
      },
      get() {
        return this.getMjestoIzlozbe;
      },
    },
    datum_izlozbe: {
      set(value) {
        this.$store.dispatch("setDatumIzlozbe", value);
      },
      get() {
        return this.getDatumIzlozbe;
      },
    },
    datum_obrane: {
      set(value) {
        this.$store.dispatch("setDatumObrane", value);
      },
      get() {
        return this.getDatumObrane;
      },
    },
    godiste: {
      set(value) {
        this.$store.dispatch("setGodiste", value);
      },
      get() {
        return this.getGodiste;
      },
    },
  },
  data: () => ({
    valid: true,
    showDialog: false,
    search: "",
  }),

  methods: {
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    openVrstaDialog: function() {
      this.showDialog = true;
    },
    createNewVrsta: async function() {
      let params = {
        naziv: this.novaVrsta,
        tipId: this.selectTip.id,
      };
      this.$store.dispatch("createNewVrsta", params);
    },
  },
  watch: {
    selectedTypeName(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit("clearTypes");
      }
    },
    selectTip(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$emit("setSelectedTip", this.selectTip);
        // Object.assign(this.types, {selectedType: this.selectTip})
      }
    },
  },
};
</script>
